import { Select } from '@tigergraph/app-ui-lib/select';
import { SelectProps } from 'baseui/select';
import { SelectOverrides } from 'baseui/select';
import { expand } from 'inline-style-expand-shorthand';

export function SourceSelect(p: SelectProps) {
  return (
    <Select
      getValueLabel={({ option }) => <span title={option.name ?? option.id}>{option.name ?? option.id}</span>}
      maxDropdownHeight={'230px'}
      size="compact"
      overrides={sourceSelectOverrides}
      {...p}
    />
  );
}

export function AttributeSelect(p: SelectProps) {
  return <SourceSelect overrides={attributeSelectOverrides} clearable={false} {...p} />;
}

export const attributeSelectOverrides: SelectOverrides = {
  ControlContainer: {
    style: ({ $isFocused }) => ({
      height: '24px',
      backgroundColor: 'inherit',
      boxSizing: 'content-box',
      ...expand({
        borderWidth: $isFocused ? '1px' : '0',
      }),
    }),
  },
  ValueContainer: {
    style: {
      paddingLeft: '2px',
      paddingTop: '0px',
      paddingBottom: '0px',
      maxWidth: '94px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
  },
  SingleValue: {
    style: {
      lineHeight: '24px',
    },
  },
  IconsContainer: {
    style: {
      paddingRight: '0px',
      paddingLeft: '0px',
    },
  },
  Popover: {
    props: {
      ignoreBoundary: true,
    },
  },
};

export const sourceSelectOverrides: SelectOverrides = {
  ...attributeSelectOverrides,
  Root: {
    style: {
      minWidth: '120px',
    },
  },
};
